import API from "../../Confgs/Axios";
import { CALCULATE_DISTANCE, FETCH_USER_BY_ROLE, FETCH_USERS, GET_ORDER_RIDE, MAP_LOCATIONS, NEAREST_DRIVERS, SET_COMBINED_MAP_LOCATIONS, SET_COORDINATE_START, SET_ID_ORDERED_RIDE, SET_STATUS_ORDERED_RIDE } from "../../Constants/actionTypes";
import { AppDispatch } from "../Reducers";

export const stateIdOrderedRide =
  (data:any) => async (dispatch:AppDispatch) => {
    try {
      dispatch({
        type: SET_ID_ORDERED_RIDE,
        payload: data
      });
    } catch (error) {
    }
  };

export const stateStatusOrderedRide =
  (data:any) => async (dispatch:AppDispatch) => {
    try {
      dispatch({
        type: SET_STATUS_ORDERED_RIDE,
        payload: data
      });
    } catch (error) {
    }
  };

export const stateCoordinateStart =
  (data:any) => async (dispatch:AppDispatch) => {
    try {
      dispatch({
        type: SET_COORDINATE_START,
        payload: data
      });
    } catch (error) {
    }
  };

export const getMapLocations = (params:any) => async (dispatch:AppDispatch) => {
  try {
    const { data } = await API.get(`/admin/map-locations?page=${params?.page}&limit=${params?.limit}`)
    dispatch({ type: MAP_LOCATIONS, payload: data });
    return data?.data;
  } catch (error) {
    return error
  }
}

export const setCombinedMapLocations =
  (data:any) => async (dispatch:AppDispatch) => {
    try {
      dispatch({
        type: SET_COMBINED_MAP_LOCATIONS,
        payload: data
      });
    } catch (error) {
    }
  };

export const getNearestDrivers = (params:any) => async (dispatch:AppDispatch) => {
  API.get(`/admin/nearest-drivers?lat=${params?.lat}&lng=${params?.lng}&max_distance=${params?.max_distance}`)
    .then((response:any) => {
      const { data } = response;
      dispatch({ type: NEAREST_DRIVERS, payload: data });
      return data;
    })
    .catch((err:any) => {
      return err
    });
};

export const getNearestDriversMobile = (params:any, ) => async (dispatch:AppDispatch) => {
  API.get(`/admin/nearest-drivers?lat=${params?.lat}&lng=${params?.lng}&max_distance=${params?.max_distance}`)
    .then((response:any) => {
      const { data } = response;
      dispatch({ type: NEAREST_DRIVERS, payload: data });
      return data
    })
    .catch((err:any) => {
      return err
    });
};

export const getCalculateDistance = (params:any, ) => async (dispatch:AppDispatch) => {
  API.get(`/admin/calculate-distance?lat1=${params?.lat1}&lng1=${params?.lng1}&lat2=${params?.lat2}&lng2=${params?.lng2}`)
    .then((response:any) => {
      const { data } = response;
      dispatch({ type: CALCULATE_DISTANCE, payload: data });
      return data
    })
    .catch((err:any) => {
      return err
    });
};

export const getCalculateDistanceMobile = (params:any, ) => async (dispatch:AppDispatch) => {
  API.get(`/admin/calculate-distance?lat1=${params?.lat1}&lng1=${params?.lng1}&lat2=${params?.lat2}&lng2=${params?.lng2}`)
    .then((response:any) => {
      const { data } = response;
      dispatch({ type: CALCULATE_DISTANCE, payload: data });
      return data
    })
    .catch((err:any) => {
      return err
    });
};

export const getOrderRide = (params:any) => async (dispatch:AppDispatch) => {
  try {
    const response = await API.get(`/admin/get-order-ride?id_trx=${params?.id_trx}&user_id_driver=${params?.user_id_driver}&user_id_customer=${params?.user_id_customer}&status=${params?.status}&page=${params?.page}&limit=${params?.limit}&invoice_no_ride=${params?.invoice_no_ride}`);
    const resAPI = response.data;
    dispatch({ type: GET_ORDER_RIDE, payload: resAPI });
    return resAPI;
  } catch (err) {
    throw err;
  }
};

export const getOrderRideMobile = (params:any, ) => async (dispatch:AppDispatch) => {
  API.get(`/admin/get-order-ride?id_trx=${params?.id_trx}&user_id_driver=${params?.user_id_driver}&user_id_customer=${params?.user_id_customer}&status=${params?.status}&page=${params?.page}&limit=${params?.limit}&invoice_no_ride=${params?.invoice_no_ride}`)
    .then((response:any) => {
      const resAPI = response.data;
      dispatch({ type: GET_ORDER_RIDE, payload: resAPI });
      return resAPI
    })
    .catch((err:any) => {
      return err
    });
};

export const getUserByRole = (param:any, ) => async (dispatch:AppDispatch) => {
  API.get(`/admin/account/${param}/role`)
    .then((response:any) => {
      const resAPI = response.data;
      dispatch({ type: FETCH_USER_BY_ROLE, payload: resAPI });
      return resAPI
    })
    .catch((err:any) => {
      return err
    });
};

export const getUsers = (currentId:any, ) => async (dispatch:AppDispatch) => {
  API.get(`/admin/account`)
    .then((response:any) => {
      const { data } = response;
      dispatch({ type: FETCH_USERS, payload: data });
      return data
    })
    .catch((err:any) => {
      return err
    });
};

export const editUser = (payload:any) => async (dispatch:AppDispatch) => {
  try {
    await API.put(`/admin/account`, payload);
    // dispatch({ type: FETCH_USERS, payload: resAPI });
  } catch (error) {
    throw error
  }
};

export const updateUserAccount = (payload:any, ) => async (dispatch:AppDispatch) => {
  try {
    const formData = new FormData();
    formData.append("name", payload.name);
    formData.append("file", payload.file);
    const { data } = await API.put(`/admin/updateUserAccount`, formData);
    return data
    // dispatch({ type: FETCH_USERS, payload: resAPI });
  } catch (error) {
    throw error
  }
};